const globalThis = require("../globalThis");

module.exports = {
  WebSocket: globalThis.WebSocket || globalThis.MozWebSocket,
  usingBrowserWebSocket: true,
  defaultBinaryType: "arraybuffer"
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/engine.io-client/lib/transports/websocket-constructor.browser.js
// module id = 752
// module chunks = 112